module.exports = __webpack_public_path__ + "media/images/logo-011992b48c2a0aaf992e5b55998ec2aa.svg";